document.addEventListener('DOMContentLoaded', () => {
    const checkoutBtn = document.querySelectorAll('button[id="CheckOut"]');

    if (!checkoutBtn.length) return;

    checkoutBtn.forEach(element => {
        element.addEventListener('click', (e) => {
           
            if (e.disabled) return;
            let old = e.innerText
            // Disable nút sau khi click
            e.disabled = true;
            e.innerText = 'loading';
            setTimeout(() => {
                e.disabled = false
                e.innerText = old;
            }, 2000);

        });
    });

    let quickAddDrawer = document.querySelector('#AjaxCartForm')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

    let quickAddDrawer1 = document.querySelector('#site-cart-sidebar')
    if (quickAddDrawer1) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(quickAddDrawer1, {
            childList: true
        });
    }

    

     let button = document.querySelectorAll('.quick-add-to-cart')
     button.forEach((e)=>{
        e.addEventListener('click', ()=>{
            setTimeout(() => {
             document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'))
             let variant = document.querySelectorAll('[bss-b2b-variant-click]')
             if (variant) {
                variant.forEach(element => {
                    element.addEventListener('click', ()=>{
                         const productForm = document.querySelector("[bss-b2b-main-product-form]");
                        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
                    })
                });
             }
            }, 2000);
           
        })
     })
     document.addEventListener('cart:updated', () => {
      BSS_B2B.observer.cartSubject.listenCartCheckout()
    });
});